import { render, staticRenderFns } from "./ExerciciosAssertivas.vue?vue&type=template&id=2bb8a184&"
import script from "./ExerciciosAssertivas.vue?vue&type=script&lang=js&"
export * from "./ExerciciosAssertivas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports